@if (gallery()) {
  <div class="dialog" [style.height.px]="height()">
    <div class="dialog-inner" appSmoothAutoHeight (height)="height.set($event)">
      @if (mode() === 'collaborators') {
        <app-share-gallery-collaborators
          [@dialogInner]
          [gallery]="gallery()"
          (editLink)="mode.set('link')"
          (inviteModeChanged)="inviteMode.set($event)"
        ></app-share-gallery-collaborators>
      } @else {
        <app-share-gallery-link
          [@dialogInner]
          [gallery]="gallery()"
          (onBack)="mode.set('collaborators')"
        ></app-share-gallery-link>
      }
    </div>
  </div>

  <ng-template #footerContent>
    <div class="dialog-bottom-inner">
      @if (gallery()) {
        @if (isTeamMember()) {
          <app-share-gallery-dialog-footer [gallery]="gallery()"> </app-share-gallery-dialog-footer>
        } @else {
          <app-share-dialog-social-footer [gallery]="gallery()"> </app-share-dialog-social-footer>
        }
      }
    </div>
  </ng-template>

  @if (publicAccessLevel() !== 'no_access' && !inviteMode()) {
    @if (isMobile) {
      <div class="dialog-bottom-container">
        <div class="dialog-bottom">
          <ng-container *ngTemplateOutlet="footerContent"></ng-container>
        </div>
      </div>
    } @else {
      <div class="dialog-bottom-container" [@dialogBottomOuter]>
        <div class="dialog-bottom-padding"></div>
        <div class="dialog-bottom" [@dialogBottomInner]>
          <ng-container *ngTemplateOutlet="footerContent"></ng-container>
        </div>
      </div>
    }
  }
} @else {
  <div class="dialog loading">
    <app-loading-indicator size="small"></app-loading-indicator>
  </div>
}
